import fetchApi from 'services/api/connector';

// eslint-disable-next-line import/prefer-default-export
export const fetchUrlPricing = () => fetchApi('cloud/portal_auth');
